import { createApp } from 'vue'

// ponytail: dynamic import per theme — Vite code-splits automatically,
// so only the active theme's bundle is loaded at runtime.
const themes = {
  orchid:   () => import('@templates/Orchid.vue'),
  dahlia:   () => import('@templates/Dahlia.vue'),
  daisy:    () => import('@templates/Daisy.vue'),
  jasmine:  () => import('@templates/Jasmine.vue'),
  sunflower: () => import('@templates/Sunflower.vue'),
  rose:     () => import('@templates/Rose.vue'),
  carnation: () => import('@templates/Carnation.vue'),
}

let vueApp = null

// Compiles a Vue SFC string (themes.vue_code, embedded as window.__THEME_SFC__)
// in the browser and mounts it. vue3-sfc-loader is dynamically imported so the
// compiler is only downloaded when a DB-stored theme is actually used.
async function mountDbTheme(el, sfcCode) {
  const [Vue, { loadModule }] = await Promise.all([
    import('vue'),
    import('vue3-sfc-loader'),
  ])
  const component = await loadModule('theme.vue', {
    moduleCache: { vue: Vue },
    getFile: () => sfcCode,
    addStyle(text) {
      const style = document.createElement('style')
      style.setAttribute('data-theme-sfc', '')
      style.textContent = text
      document.head.appendChild(style)
    },
  })
  vueApp = createApp(component)
  vueApp.mount(el)
}

async function mountTheme() {
  const el = document.querySelector('[data-theme-app]')
  if (!el) return

  // Bundled theme components take priority over DB-stored Vue code
  let mounted = false
  for (const [name, load] of Object.entries(themes)) {
    const el = document.getElementById(`${name}-app`)
    if (!el) continue
    if (vueApp) vueApp.unmount()
    const { default: Component } = await load()
    vueApp = createApp(Component)
    vueApp.mount(el)
    mounted = true
    break
  }

  // DB-stored Vue code (themes.vue_code) is the last fallback,
  // only used when no bundled theme component matches.
  if (!mounted && window.__THEME_SFC__) {
    if (vueApp) vueApp.unmount()
    document.querySelectorAll('style[data-theme-sfc]').forEach((s) => s.remove())
    await mountDbTheme(el, window.__THEME_SFC__)
  }
}

document.addEventListener('turbo:before-cache', () => {
  if (vueApp) { vueApp.unmount(); vueApp = null }
})

document.addEventListener('turbo:load', mountTheme)
